import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import './B21-brand-list.scss';

class B2HomepageHero extends Abstract {
	init() {
		const sliderEl = this.root.querySelector('.swiper-container');
		const prevEl = this.root.querySelector('.swiper-nav-btn--prev');
		const nextEl = this.root.querySelector('.swiper-nav-btn--next');

		this.slider = new Slider(sliderEl, {
			slidesPerView: 1, // Explicitly set to fix IE11 slide miscalculation
			speed: 500,
			navigation: {
				prevEl,
				nextEl,
			},
			simulateTouch: false,
		});
	}
}

export default B2HomepageHero;
